class SmallFormatMenuPanelController {}

const smallFormatMenuPanelComponentDefinition = {
    bindings: {
        navigationItem: '<',
        onClickBack: '&',
        onNavigationItemSelect: '&?',
    },
    controller: SmallFormatMenuPanelController,
    template: require('./small-format-menu-panel.component.html').trim(),
};

module.exports = {
    SmallFormatMenuPanelController,
    smallFormatMenuPanelComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/common/smallformatmenu/small-format-menu-panel.component.js